import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  CreateRouteConfigurationRequest,
  ExportRouteConfigurationsResponse,
  GetRouteConfigurationsRequest,
  GetRouteConfigurationsResponse,
  ImportRouteConfigurationsRequest,
  RouteConfigurationResponse,
  RouteMigrationRequest,
  RouteMigrationResponse,
  ValidateImportRouteConfigurationsCommandResponse,
} from '../../models/route-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class RouteConfigurationService {
  private api = `${environment.baseV5ApiUri}/route-configurations`;

  constructor(private http: HttpClient) {}

  getFiltered(request: GetRouteConfigurationsRequest): Observable<GetRouteConfigurationsResponse> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(request)) {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, value.toString());
      }
    }

    return this.http.get<GetRouteConfigurationsResponse>(this.api, { params });
  }

  create(request: CreateRouteConfigurationRequest): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(this.api, request);
  }

  getById(id: string): Observable<RouteConfigurationResponse> {
    return this.http.get<RouteConfigurationResponse>(`${this.api}/${id}`);
  }

  update(id: string, request: CreateRouteConfigurationRequest): Observable<void> {
    return this.http.put<void>(`${this.api}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.api}/${id}`);
  }

  bulkDelete(ids: string[]): Observable<void> {
    return this.http.post<void>(`${this.api}/bulk-delete`, { ids });
  }

  export(ids: string[]): Observable<ExportRouteConfigurationsResponse> {
    return this.http.post<ExportRouteConfigurationsResponse>(`${this.api}/export`, ids);
  }

  validateImport(file: File): Observable<ValidateImportRouteConfigurationsCommandResponse> {
    const formData = new FormData();
    formData.append('json', file);

    return this.http.post<ValidateImportRouteConfigurationsCommandResponse>(
      `${this.api}/validate-import`,
      formData
    );
  }

  importEntities(request: ImportRouteConfigurationsRequest): Observable<string[]> {
    return this.http.post<string[]>(`${this.api}/import`, request);
  }

  migrate(request: RouteMigrationRequest): Observable<RouteMigrationResponse> {
    return this.http.post<RouteMigrationResponse>(`${this.api}/migrate`, request);
  }

  migrateDryRun(request: RouteMigrationRequest): Observable<RouteMigrationResponse> {
    return this.http.post<RouteMigrationResponse>(`${this.api}/migrate/dry-run`, request);
  }

  reorder(id: string, order: number): Observable<void> {
    return this.http.post<void>(`${this.api}/reorder`, { id, order });
  }
}
